import { withDisabledPropertyInContentForm } from "@hoc/withDisabledPropertyInContentForm";
import { WithArhivedStatusReturnType } from "@providers/ArchivedContentProvider";
import { FieldExternalIdentifier } from "@services/FormUtils/FormFields";
import { Input } from "antd";
import { ChangeEvent } from "react";
import {
  WithPermissionsToInteractReturnType,
  withPermissionsToInteract,
} from "../../providers/UserPermissionsProvider";

export interface Props extends WithPermissionsToInteractReturnType, WithArhivedStatusReturnType {
  field: FieldExternalIdentifier;
}

export interface Injected extends Props {
  onChange(value: any): any;
}

function ContentExternalIdentifierInput(props: Props) {
  const injected = props as Injected;
  function onChange(e: ChangeEvent<HTMLInputElement>) {
    props.field.setFieldValue(e.target.value);
    return injected.onChange(e.target.value);
  }

  function onBlur(e: ChangeEvent<HTMLInputElement>) {
    const trimmedValue = props.field.trimValue(e.target.value);
    return injected.onChange(trimmedValue);
  }

  const { field, hasPermissions, archived, ...others } = props;
  const disabled = archived || !hasPermissions;
  return <Input {...others} disabled={disabled} type="text" value={field.value} onChange={onChange} onBlur={onBlur} />;
}

export default withDisabledPropertyInContentForm(withPermissionsToInteract(ContentExternalIdentifierInput));
